var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "loader" }, [
        _c("div", { staticClass: "spinner-container" }, [
          _c("div", { staticClass: "loading_msg" }, [
            _c("div", {}, [_vm._v(_vm._s(_vm.loading_msg))]),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
          ]),
        ]),
      ])
    : !_vm.loading
    ? _c("div", [
        _c("div", { staticClass: "content-block" }, [
          _vm.page == 1
            ? _c(
                "div",
                { staticClass: "page", attrs: { "data-page": "1" } },
                [
                  _c("section", [
                    _c("div", { staticClass: "pd-2 dark" }, [
                      _c("div", { staticClass: "container" }, [
                        _c("h1", [_vm._v("What is your name?")]),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v("As it appears on the NSW electoral Roll"),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant1.prefix_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Prefix")]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.applicant1.prefix,
                                        expression: "applicant1.prefix",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { id: "applicant1_prefix" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.applicant1,
                                          "prefix",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [_vm._v("Please Select")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.prefixes, function (prefix) {
                                      return _c(
                                        "option",
                                        {
                                          key: prefix.CODE,
                                          domProps: { value: prefix.CODE },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(prefix.CODE) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.applicant1.prefix_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please select your prefix"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant1.first_name_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("First Name")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.first_name,
                                      expression: "applicant1.first_name",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applicant1_first_name",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.applicant1.first_name,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1,
                                        "first_name",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.first_name_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your first name"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Middle name(s)")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.applicant1.middle_name,
                                    expression: "applicant1.middle_name",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Enter if you have one",
                                },
                                domProps: { value: _vm.applicant1.middle_name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.applicant1,
                                      "middle_name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant1.last_name_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Last Name")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.last_name,
                                      expression: "applicant1.last_name",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applicant1_last_name",
                                    type: "text",
                                  },
                                  domProps: { value: _vm.applicant1.last_name },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1,
                                        "last_name",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.last_name_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your last name"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c("div", { staticClass: "pd-2" }, [
                      _c(
                        "div",
                        { staticClass: "container" },
                        [
                          _c("h1", [_vm._v("Your Date of Birth ")]),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "text-left col-md-5" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    input_error:
                                      _vm.applicant1.date_of_birth_error,
                                  },
                                },
                                [
                                  _c("label", [_vm._v("DOB")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { id: "applicant1_date_of_birth" },
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.applicant1Day,
                                              expression: "applicant1Day",
                                            },
                                          ],
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.applicant1Day = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "null",
                                                disabled: "",
                                              },
                                            },
                                            [_vm._v("Day")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.applicantDob_days,
                                            function (day) {
                                              return _c(
                                                "option",
                                                { domProps: { value: day } },
                                                [_vm._v(_vm._s(day))]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.applicant1Month,
                                              expression: "applicant1Month",
                                            },
                                          ],
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.applicant1Month = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("Month")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.applicantDob_months,
                                            function (month) {
                                              return _c(
                                                "option",
                                                { domProps: { value: month } },
                                                [_vm._v(_vm._s(month))]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.applicant1Year,
                                              expression: "applicant1Year",
                                            },
                                          ],
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.applicant1Year = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("Year")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.applicantDob_years,
                                            function (year) {
                                              return _c(
                                                "option",
                                                { domProps: { value: year } },
                                                [_vm._v(_vm._s(year))]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.applicant1.date_of_birth_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              "Please select a valid date"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "fade" } }, [
                            _vm.is_young_liberal_eligible && !_vm.isJoint
                              ? _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-5" }, [
                                    _c("div", { staticClass: "bt-lh" }, [
                                      _c("label", [
                                        _vm._v(
                                          "Would you like to join the Party as a Young Liberal?"
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-7" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-primary",
                                        class: { active: _vm.is_young_liberal },
                                        on: { click: _vm.add_young_liberal },
                                      },
                                      [_vm._v("Yes")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-primary",
                                        class: {
                                          active: _vm.is_not_young_liberal,
                                        },
                                        on: { click: _vm.remove_young_liberal },
                                      },
                                      [_vm._v("No")]
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  !_vm.is_young_liberal
                    ? _c("section", [
                        _c("div", { staticClass: "pd-2 dark" }, [
                          _c("div", { staticClass: "container" }, [
                            _c("div", { staticClass: "row" }, [
                              _vm._m(0),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-7" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-primary",
                                    class: { active: _vm.isSingle },
                                    attrs: { id: "btn-single-applicant" },
                                    on: { click: _vm.single_applicant },
                                  },
                                  [_vm._v("Single")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-primary",
                                    class: { active: _vm.isJoint },
                                    attrs: { id: "btn-joint-applicant" },
                                    on: { click: _vm.joint_applicant },
                                  },
                                  [_vm._v("Joint")]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.isJoint
                      ? _c("div", [
                          _c("section", [
                            _c("div", { staticClass: "pd-2" }, [
                              _c("div", { staticClass: "container" }, [
                                _c("h1", [
                                  _vm._v(
                                    "What is the second applicant's name?"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("label", [
                                  _vm._v(
                                    "As it appears on the NSW electoral Roll"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("hr"),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.applicant2.prefix_error,
                                        },
                                      },
                                      [
                                        _c("label", [_vm._v("Prefix")]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.applicant2.prefix,
                                                expression: "applicant2.prefix",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { id: "applicant2_prefix" },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.applicant2,
                                                  "prefix",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { domProps: { value: null } },
                                              [_vm._v("Please Select")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.prefixes,
                                              function (prefix) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: prefix.CODE,
                                                    domProps: {
                                                      value: prefix.CODE,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(prefix.CODE) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.applicant2.prefix_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please select second applicant prefix"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.applicant2.first_name_error,
                                        },
                                      },
                                      [
                                        _c("label", [_vm._v("First Name")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.applicant2.first_name,
                                              expression:
                                                "applicant2.first_name",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "applicant2_first_name",
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.applicant2.first_name,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.applicant2,
                                                "first_name",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.applicant2.first_name_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter second applicant first name"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("label", [_vm._v("Middle name(s)")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.applicant2.middle_name,
                                            expression:
                                              "applicant2.middle_name",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Enter if you have one",
                                        },
                                        domProps: {
                                          value: _vm.applicant2.middle_name,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2,
                                              "middle_name",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.applicant2.last_name_error,
                                        },
                                      },
                                      [
                                        _c("label", [_vm._v("Last Name")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.applicant2.last_name,
                                              expression:
                                                "applicant2.last_name",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "applicant2_last_name",
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.applicant2.last_name,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.applicant2,
                                                "last_name",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.applicant2.last_name_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter second applicant last name"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("section", [
                            _c("div", { staticClass: "pd-2 dark" }, [
                              _c("div", { staticClass: "container" }, [
                                _c("h1", [
                                  _vm._v("What is "),
                                  _c("span", { staticClass: "txtcap" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.applicant2.first_name ||
                                          "the second applicant"
                                      ) + "’s"
                                    ),
                                  ]),
                                  _vm._v(" Date\n                  of Birth?"),
                                ]),
                                _vm._v(" "),
                                _c("hr"),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.applicant2.date_of_birth_error,
                                        },
                                      },
                                      [
                                        _c("label", [_vm._v("DOB")]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: {
                                              id: "applicant2_date_of_birth",
                                            },
                                          },
                                          [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.applicant2Day,
                                                    expression: "applicant2Day",
                                                  },
                                                ],
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.applicant2Day = $event
                                                      .target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "null",
                                                      disabled: "",
                                                    },
                                                  },
                                                  [_vm._v("Day")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.applicantDob_days,
                                                  function (day) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: day,
                                                        domProps: {
                                                          value: day,
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(day))]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.applicant2Month,
                                                    expression:
                                                      "applicant2Month",
                                                  },
                                                ],
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.applicant2Month = $event
                                                      .target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "null",
                                                      disabled: "",
                                                    },
                                                  },
                                                  [_vm._v("Month")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.applicantDob_months,
                                                  function (month) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: month,
                                                        domProps: {
                                                          value: month,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(month) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.applicant2Year,
                                                    expression:
                                                      "applicant2Year",
                                                  },
                                                ],
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.applicant2Year = $event
                                                      .target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "null",
                                                      disabled: "",
                                                    },
                                                  },
                                                  [_vm._v("Year")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.applicantDob_years,
                                                  function (year) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: year,
                                                        domProps: {
                                                          value: year,
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(year))]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _vm.applicant2.date_of_birth_error
                                              ? _c(
                                                  "span",
                                                  { staticClass: "error" },
                                                  [
                                                    _vm._v(
                                                      "Please select a valid date"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c("div", { staticClass: "pd-2 dark" }, [
                      _c("div", { staticClass: "container" }, [
                        _c("h1", [
                          _c("span", { staticClass: "txtcap" }, [
                            _vm._v(
                              _vm._s(
                                _vm.applicant1.first_name || "First Applicant"
                              ) + "’s"
                            ),
                          ]),
                          _vm._v(" Contact Information"),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant1.email_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Email")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.email,
                                      expression: "applicant1.email",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applicant1_email",
                                    type: "text",
                                  },
                                  domProps: { value: _vm.applicant1.email },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1,
                                        "email",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.email_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter a valid email"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.mobile_phone_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Mobile number")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.mobile_phone,
                                      expression: "applicant1.mobile_phone",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applicant1_mobile_phone",
                                    type: "text",
                                    placeholder: "",
                                  },
                                  domProps: {
                                    value: _vm.applicant1.mobile_phone,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1,
                                        "mobile_phone",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.mobile_phone_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your mobile phone"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant1.home_phone_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Home number")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.home_phone,
                                      expression: "applicant1.home_phone",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applicant1_home_phone",
                                    type: "text",
                                    placeholder: "Enter if you have one",
                                  },
                                  domProps: {
                                    value: _vm.applicant1.home_phone,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1,
                                        "home_phone",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.home_phone_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your home phone"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.applicant1.address.validate_errormob
                          ? _c("p", { staticClass: "input_error" }, [
                              _c("strong", [
                                _vm._v(
                                  "You must enter in a valid Australian mobile number, if you do not have one then please complete\n                a manual join form or call 02 8356 0300."
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.isJoint
                          ? _c("div", [
                              _c("h1", [
                                _c("span", { staticClass: "txtcap" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.applicant2.first_name ||
                                        "Second applicant"
                                    ) + "’s"
                                  ),
                                ]),
                                _vm._v(" Contact Information\n              "),
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error: _vm.applicant2.email_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Email")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.applicant2.email,
                                            expression: "applicant2.email",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "applicant2_email",
                                          type: "text",
                                        },
                                        domProps: {
                                          value: _vm.applicant2.email,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2,
                                              "email",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.email_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              "Please enter a valid email"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.mobile_phone_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Mobile number")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.applicant2.mobile_phone,
                                            expression:
                                              "applicant2.mobile_phone",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "applicant2_mobile_phone",
                                          type: "text",
                                          placeholder: "",
                                        },
                                        domProps: {
                                          value: _vm.applicant2.mobile_phone,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2,
                                              "mobile_phone",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.mobile_phone_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v("Please enter "),
                                            _c(
                                              "span",
                                              { staticClass: "txtcap" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.applicant2.first_name
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm.applicant2.first_name
                                              ? _c("span", [_vm._v("'s")])
                                              : _vm._e(),
                                            _vm._v(" mobile phone"),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.home_phone_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Home number")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.applicant2.home_phone,
                                            expression: "applicant2.home_phone",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "applicant2_home_phone",
                                          type: "text",
                                          placeholder: "Enter if you have one",
                                        },
                                        domProps: {
                                          value: _vm.applicant2.home_phone,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2,
                                              "home_phone",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.home_phone_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v("Please enter "),
                                            _c(
                                              "span",
                                              { staticClass: "txtcap" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.applicant2.first_name
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm.applicant2.first_name
                                              ? _c("span", [_vm._v("'s")])
                                              : _vm._e(),
                                            _vm._v(" home phone"),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.applicant2.address.validate_errormob
                                ? _c("p", { staticClass: "input_error" }, [
                                    _c("strong", [
                                      _vm._v(
                                        "You must enter in a valid Australian mobile number, if you do not have one then please\n                  complete a manual join form or call 02 8356 0300."
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c("div", { staticClass: "pd-2 dark" }, [
                      _c("div", { staticClass: "container" }, [
                        _c("h1", [_vm._v("Your Electoral Roll Details")]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "txtcap" }, [
                          _vm._v(_vm._s(_vm.applicant1.first_name)),
                        ]),
                        _vm._v(" "),
                        _c("label", { attrs: { id: "address1-validate" } }, [
                          _vm._v("Electoral Roll Address"),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.address.street_number_error,
                                },
                              },
                              [
                                _c("label", [
                                  _vm._v("Unit No and/or Street No"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.applicant1.address.street_number,
                                      expression:
                                        "applicant1.address.street_number",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    maxlength: "40",
                                    id: "applicant1_street_number",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.applicant1.address.street_number,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1.address,
                                        "street_number",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.address.street_number_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your street number"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.address.street_name_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Street name")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.address.street_name,
                                      expression:
                                        "applicant1.address.street_name",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applicant1_street_name",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.applicant1.address.street_name,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1.address,
                                        "street_name",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.address.street_name_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your street name"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.address.street_type_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Street type")]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.applicant1.address.street_type,
                                        expression:
                                          "applicant1.address.street_type",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { id: "applicant1_street_type" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.applicant1.address,
                                          "street_type",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [_vm._v("Please Select")]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "None" } }, [
                                      _vm._v("None"),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.street_types,
                                      function (street_type) {
                                        return _c(
                                          "option",
                                          {
                                            domProps: {
                                              value: street_type.CODE,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(street_type.CODE) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.applicant1.address.street_type_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your street type"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.address.suburb_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Suburb")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.address.suburb,
                                      expression: "applicant1.address.suburb",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applicant1_suburb",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.applicant1.address.suburb,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1.address,
                                        "suburb",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.address.suburb_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your suburb"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.address.state_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("State")]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.applicant1.address.state,
                                        expression: "applicant1.address.state",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { id: "applicant1_state" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.applicant1.address,
                                          "state",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("Select State"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "ACT" } }, [
                                      _vm._v("ACT"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "NSW" } }, [
                                      _vm._v("NSW"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "NT" } }, [
                                      _vm._v("NT"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "QLD" } }, [
                                      _vm._v("QLD"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "SA" } }, [
                                      _vm._v("SA"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "TAS" } }, [
                                      _vm._v("TAS"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "VIC" } }, [
                                      _vm._v("VIC"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "WA" } }, [
                                      _vm._v("WA"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.applicant1.address.state_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your state"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.address.post_code_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Postcode")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.address.post_code,
                                      expression:
                                        "applicant1.address.post_code",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applicant1_post_code",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.applicant1.address.post_code,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1.address,
                                        "post_code",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.address.post_code_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your postcode"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.applicant1.address.validate_error
                          ? _c("p", { staticClass: "input_error" }, [_vm._m(1)])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.applicant1.address.validate_errorelectoral2
                          ? _c("p", { staticClass: "input_error" }, [
                              _c("strong", [
                                _vm._v(
                                  "We haven't been able to verify that your name matches your electoral roll address, please\n                contact us on (02) 8356 0300 during office hours to continue your application."
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.applicant1.address.validate_duplicate
                          ? _c("p", { staticClass: "input_error" }, [
                              _c("strong", [
                                _vm._v(
                                  "You are not able to complete the application process. Please contact (02) 8356 0300 to discuss\n                your application."
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.isJoint
                          ? _c("div", [
                              _c("h3", { staticClass: "txtcap" }, [
                                _vm._v(_vm._s(_vm.applicant2.first_name)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.applicant2.address.same_as,
                                        expression:
                                          "applicant2.address.same_as",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "same_address",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.applicant2.address.same_as
                                      )
                                        ? _vm._i(
                                            _vm.applicant2.address.same_as,
                                            null
                                          ) > -1
                                        : _vm.applicant2.address.same_as,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.applicant2.address.same_as,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.applicant2.address,
                                                "same_as",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.applicant2.address,
                                                "same_as",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.applicant2.address,
                                            "same_as",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                  Please tick this box if your electoral roll details are the same as above.\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("label", [_vm._v("Electoral Roll Address")]),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.address
                                            .street_number_error,
                                      },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v("Unit No and/or Street No"),
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.applicant2.address
                                                .street_number,
                                            expression:
                                              "applicant2.address.street_number",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled:
                                            _vm.applicant2.address.same_as,
                                          id: "applicant2_street_number",
                                          type: "text",
                                          maxlength: "40",
                                        },
                                        domProps: {
                                          value:
                                            _vm.applicant2.address
                                              .street_number,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2.address,
                                              "street_number",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.address.street_number_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              "Please enter your street number"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.address
                                            .street_name_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Street name")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.applicant2.address
                                                .street_name,
                                            expression:
                                              "applicant2.address.street_name",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled:
                                            _vm.applicant2.address.same_as,
                                          id: "applicant2_street_name",
                                          type: "text",
                                        },
                                        domProps: {
                                          value:
                                            _vm.applicant2.address.street_name,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2.address,
                                              "street_name",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.address.street_name_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              "Please enter your street name"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.address
                                            .street_type_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Street type")]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2.address
                                                  .street_type,
                                              expression:
                                                "applicant2.address.street_type",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled:
                                              _vm.applicant2.address.same_as,
                                            id: "applicant2_street_type",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.applicant2.address,
                                                "street_type",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("Please Select")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "None" } },
                                            [_vm._v("None")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.street_types,
                                            function (street_type) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: street_type.CODE,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(street_type.CODE) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.applicant2.address.street_type_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              "Please enter your street type"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.address.suburb_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Suburb")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.applicant2.address.suburb,
                                            expression:
                                              "applicant2.address.suburb",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled:
                                            _vm.applicant2.address.same_as,
                                          id: "applicant2_suburb",
                                          type: "text",
                                        },
                                        domProps: {
                                          value: _vm.applicant2.address.suburb,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2.address,
                                              "suburb",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.address.suburb_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v("Please enter your suburb"),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.address.state_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("State")]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2.address.state,
                                              expression:
                                                "applicant2.address.state",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled:
                                              _vm.applicant2.address.same_as,
                                            id: "applicant2_state",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.applicant2.address,
                                                "state",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [_vm._v("Select State")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "ACT" } },
                                            [_vm._v("ACT")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "NSW" } },
                                            [_vm._v("NSW")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "NT" } },
                                            [_vm._v("NT")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "QLD" } },
                                            [_vm._v("QLD")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SA" } },
                                            [_vm._v("SA")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "TAS" } },
                                            [_vm._v("TAS")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "VIC" } },
                                            [_vm._v("VIC")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "WA" } },
                                            [_vm._v("WA")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.applicant2.address.state_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v("Please enter your state"),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.address
                                            .post_code_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Postcode")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.applicant2.address.post_code,
                                            expression:
                                              "applicant2.address.post_code",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled:
                                            _vm.applicant2.address.same_as,
                                          id: "applicant2_post_code",
                                          type: "text",
                                        },
                                        domProps: {
                                          value:
                                            _vm.applicant2.address.post_code,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2.address,
                                              "post_code",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.address.post_code_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              "Please enter your postcode"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.applicant2.address.validate_error
                                ? _c("p", { staticClass: "input_error" }, [
                                    _vm._m(2),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.applicant2.address.validate_errorelectoral2
                                ? _c("p", { staticClass: "input_error" }, [
                                    _c("strong", [
                                      _vm._v(
                                        "We haven't been able to verify that your name matches your electoral role address, please\n                  contact us on (02) 8356 0300 during office hours to continue your application."
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.applicant2.address.validate_duplicate
                                ? _c("p", { staticClass: "input_error" }, [
                                    _c("strong", [
                                      _vm._v(
                                        "You are not able to complete the application process. Please contact (02) 8356 0300 to discuss\n                  your application."
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c("div", { staticClass: "pd-2 dark" }, [
                      _c("div", { staticClass: "container" }, [
                        _c("h1", [_vm._v("Your Postal Address Details")]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "txtcap" }, [
                          _vm._v(_vm._s(_vm.applicant1.first_name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.applicant1.postaladdress.same_as,
                                  expression:
                                    "applicant1.postaladdress.same_as",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: "same_postaladdress1",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.applicant1.postaladdress.same_as
                                )
                                  ? _vm._i(
                                      _vm.applicant1.postaladdress.same_as,
                                      null
                                    ) > -1
                                  : _vm.applicant1.postaladdress.same_as,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.applicant1.postaladdress.same_as,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.applicant1.postaladdress,
                                          "same_as",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.applicant1.postaladdress,
                                          "same_as",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.applicant1.postaladdress,
                                      "same_as",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              "\n                Please tick this box if your postal address same as electoral roll details as above.\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("label", [_vm._v("Postal Address")]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.applicant1.postaladdress.use_pobox,
                                  expression:
                                    "applicant1.postaladdress.use_pobox",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: "applicant1_chkuse_pobox",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.applicant1.postaladdress.use_pobox
                                )
                                  ? _vm._i(
                                      _vm.applicant1.postaladdress.use_pobox,
                                      null
                                    ) > -1
                                  : _vm.applicant1.postaladdress.use_pobox,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.applicant1.postaladdress.use_pobox,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.applicant1.postaladdress,
                                          "use_pobox",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.applicant1.postaladdress,
                                          "use_pobox",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.applicant1.postaladdress,
                                      "use_pobox",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              "\n                My postal address is a PO Box address\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        !_vm.applicant1.postaladdress.use_pobox
                          ? _c(
                              "section",
                              { attrs: { id: "applicant1_pobox_street" } },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.applicant1.postaladdress
                                              .street_number_error,
                                        },
                                      },
                                      [
                                        _c("label", [
                                          _vm._v("Unit No and/or Street No"),
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant1.postaladdress
                                                  .street_number,
                                              expression:
                                                "applicant1.postaladdress.street_number",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled:
                                              _vm.applicant1.postaladdress
                                                .same_as,
                                            maxlength: "40",
                                            id: "applicant1_postaladdress_street_number",
                                            type: "text",
                                          },
                                          domProps: {
                                            value:
                                              _vm.applicant1.postaladdress
                                                .street_number,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.applicant1.postaladdress,
                                                "street_number",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.applicant1.postaladdress
                                          .street_number_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter your street number"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.applicant1.postaladdress
                                              .street_name_error,
                                        },
                                      },
                                      [
                                        _c("label", [_vm._v("Street name")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant1.postaladdress
                                                  .street_name,
                                              expression:
                                                "applicant1.postaladdress.street_name",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled:
                                              _vm.applicant1.postaladdress
                                                .same_as,
                                            id: "applicant1_postaladdress_street_name",
                                            type: "text",
                                          },
                                          domProps: {
                                            value:
                                              _vm.applicant1.postaladdress
                                                .street_name,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.applicant1.postaladdress,
                                                "street_name",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.applicant1.postaladdress
                                          .street_name_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter your street name"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.applicant1.postaladdress
                                              .street_type_error,
                                        },
                                      },
                                      [
                                        _c("label", [_vm._v("Street type")]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.applicant1.postaladdress
                                                    .street_type,
                                                expression:
                                                  "applicant1.postaladdress.street_type",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              disabled:
                                                _vm.applicant1.postaladdress
                                                  .same_as,
                                              id: "applicant1_postaladdress_street_type",
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.applicant1.postaladdress,
                                                  "street_type",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { domProps: { value: null } },
                                              [_vm._v("Please Select")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "None" } },
                                              [_vm._v("None")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.street_types,
                                              function (street_type) {
                                                return _c(
                                                  "option",
                                                  {
                                                    domProps: {
                                                      value: street_type.CODE,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(street_type.CODE) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.applicant1.postaladdress
                                          .street_type_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter your street type"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.applicant1.postaladdress.use_pobox
                          ? _c(
                              "section",
                              { attrs: { id: "applicant1_pobox_address1" } },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.applicant1.postaladdress
                                              .address1_error,
                                        },
                                      },
                                      [
                                        _c("label", [_vm._v("PO Box Details")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant1.postaladdress
                                                  .address1,
                                              expression:
                                                "applicant1.postaladdress.address1",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            maxlength: "100",
                                            id: "applicant1_postaladdress_address",
                                            type: "text",
                                          },
                                          domProps: {
                                            value:
                                              _vm.applicant1.postaladdress
                                                .address1,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.applicant1.postaladdress,
                                                "address1",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.applicant1.postaladdress
                                          .address1_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter your PO Box details"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.postaladdress.suburb_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Suburb")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.applicant1.postaladdress.suburb,
                                      expression:
                                        "applicant1.postaladdress.suburb",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    disabled:
                                      _vm.applicant1.postaladdress.same_as,
                                    id: "applicant1_postaladdress_suburb",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.applicant1.postaladdress.suburb,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1.postaladdress,
                                        "suburb",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.postaladdress.suburb_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your suburb"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.postaladdress.state_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("State")]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.applicant1.postaladdress.state,
                                        expression:
                                          "applicant1.postaladdress.state",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      disabled:
                                        _vm.applicant1.postaladdress.same_as,
                                      id: "applicant1_postaladdress_state",
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.applicant1.postaladdress,
                                          "state",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("Select State"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "ACT" } }, [
                                      _vm._v("ACT"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "NSW" } }, [
                                      _vm._v("NSW"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "NT" } }, [
                                      _vm._v("NT"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "QLD" } }, [
                                      _vm._v("QLD"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "SA" } }, [
                                      _vm._v("SA"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "TAS" } }, [
                                      _vm._v("TAS"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "VIC" } }, [
                                      _vm._v("VIC"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "WA" } }, [
                                      _vm._v("WA"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.applicant1.postaladdress.state_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your state"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant1.postaladdress
                                      .post_code_error,
                                },
                              },
                              [
                                _c("label", [_vm._v("Postcode")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.applicant1.postaladdress.post_code,
                                      expression:
                                        "applicant1.postaladdress.post_code",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    disabled:
                                      _vm.applicant1.postaladdress.same_as,
                                    id: "applicant1_postaladdress_post_code",
                                    type: "text",
                                  },
                                  domProps: {
                                    value:
                                      _vm.applicant1.postaladdress.post_code,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.applicant1.postaladdress,
                                        "post_code",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.postaladdress.post_code_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please enter your postcode"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.applicant1.postaladdress.validate_error
                          ? _c("p", { staticClass: "input_error" }, [_vm._m(3)])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.applicant1.postaladdress.validate_errorelectoral2
                          ? _c("p", { staticClass: "input_error" }, [
                              _c("strong", [
                                _vm._v(
                                  "We haven't been able to verify that your name matches your electoral role address, please\n                contact us on (02) 8356 0300 during office hours to continue your application."
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.applicant1.postaladdress.validate_duplicate
                          ? _c("p", { staticClass: "input_error" }, [
                              _c("strong", [
                                _vm._v(
                                  "You are not able to complete the application process. Please contact (02) 8356 0300 to discuss\n                your application."
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.isJoint
                          ? _c("div", [
                              _c("h3", { staticClass: "txtcap" }, [
                                _vm._v(_vm._s(_vm.applicant2.first_name)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.applicant2.postaladdress.same_as,
                                        expression:
                                          "applicant2.postaladdress.same_as",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "same_postaladdress2",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.applicant2.postaladdress.same_as
                                      )
                                        ? _vm._i(
                                            _vm.applicant2.postaladdress
                                              .same_as,
                                            null
                                          ) > -1
                                        : _vm.applicant2.postaladdress.same_as,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.applicant2.postaladdress
                                              .same_as,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.applicant2.postaladdress,
                                                "same_as",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.applicant2.postaladdress,
                                                "same_as",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.applicant2.postaladdress,
                                            "same_as",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                  Please tick this box if your postal address same as electoral roll details as above.\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("label", [_vm._v("Postal Address")]),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.applicant2.postaladdress
                                            .use_pobox,
                                        expression:
                                          "applicant2.postaladdress.use_pobox",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "applicant2_chkuse_pobox",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.applicant2.postaladdress.use_pobox
                                      )
                                        ? _vm._i(
                                            _vm.applicant2.postaladdress
                                              .use_pobox,
                                            null
                                          ) > -1
                                        : _vm.applicant2.postaladdress
                                            .use_pobox,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.applicant2.postaladdress
                                              .use_pobox,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.applicant2.postaladdress,
                                                "use_pobox",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.applicant2.postaladdress,
                                                "use_pobox",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.applicant2.postaladdress,
                                            "use_pobox",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                  My postal address is a PO Box address\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              !_vm.applicant2.postaladdress.use_pobox
                                ? _c(
                                    "section",
                                    {
                                      attrs: { id: "applicant2_pobox_street" },
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-md-4" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group",
                                              class: {
                                                input_error:
                                                  _vm.applicant2.postaladdress
                                                    .street_number_error,
                                              },
                                            },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  "Unit No and/or Street No"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.applicant2
                                                        .postaladdress
                                                        .street_number,
                                                    expression:
                                                      "applicant2.postaladdress.street_number",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  disabled:
                                                    _vm.applicant2.postaladdress
                                                      .same_as,
                                                  id: "applicant2_postaladdress_street_number",
                                                  type: "text",
                                                  maxlength: "40",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.applicant2.postaladdress
                                                      .street_number,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.applicant2
                                                        .postaladdress,
                                                      "street_number",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.applicant2.postaladdress
                                                .street_number_error
                                                ? _c(
                                                    "span",
                                                    { staticClass: "error" },
                                                    [
                                                      _vm._v(
                                                        "Please enter your street number"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group",
                                              class: {
                                                input_error:
                                                  _vm.applicant2.postaladdress
                                                    .street_name_error,
                                              },
                                            },
                                            [
                                              _c("label", [
                                                _vm._v("Street name"),
                                              ]),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.applicant2
                                                        .postaladdress
                                                        .street_name,
                                                    expression:
                                                      "applicant2.postaladdress.street_name",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  disabled:
                                                    _vm.applicant2.postaladdress
                                                      .same_as,
                                                  id: "applicant2_postaladdress_street_name",
                                                  type: "text",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.applicant2.postaladdress
                                                      .street_name,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.applicant2
                                                        .postaladdress,
                                                      "street_name",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.applicant2.postaladdress
                                                .street_name_error
                                                ? _c(
                                                    "span",
                                                    { staticClass: "error" },
                                                    [
                                                      _vm._v(
                                                        "Please enter your street name"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-2" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group",
                                              class: {
                                                input_error:
                                                  _vm.applicant2.postaladdress
                                                    .street_type_error,
                                              },
                                            },
                                            [
                                              _c("label", [
                                                _vm._v("Street type"),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.applicant2
                                                          .postaladdress
                                                          .street_type,
                                                      expression:
                                                        "applicant2.postaladdress.street_type",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    disabled:
                                                      _vm.applicant2
                                                        .postaladdress.same_as,
                                                    id: "applicant2_postaladdress_street_type",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        _vm.applicant2
                                                          .postaladdress,
                                                        "street_type",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: null },
                                                    },
                                                    [_vm._v("Please Select")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "None" },
                                                    },
                                                    [_vm._v("None")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.street_types,
                                                    function (street_type) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          domProps: {
                                                            value:
                                                              street_type.CODE,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              street_type.CODE
                                                            ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _vm.applicant2.postaladdress
                                                .street_type_error
                                                ? _c(
                                                    "span",
                                                    { staticClass: "error" },
                                                    [
                                                      _vm._v(
                                                        "Please enter your street type"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.applicant2.postaladdress.use_pobox
                                ? _c(
                                    "section",
                                    {
                                      attrs: {
                                        id: "applicant2_pobox_address1",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group",
                                              class: {
                                                input_error:
                                                  _vm.applicant2.postaladdress
                                                    .address1_error,
                                              },
                                            },
                                            [
                                              _c("label", [
                                                _vm._v("PO Box Details"),
                                              ]),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.applicant2
                                                        .postaladdress.address1,
                                                    expression:
                                                      "applicant2.postaladdress.address1",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  maxlength: "100",
                                                  id: "applicant2_postaladdress_address",
                                                  type: "text",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.applicant2.postaladdress
                                                      .address1,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.applicant2
                                                        .postaladdress,
                                                      "address1",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.applicant2.postaladdress
                                                .address1_error
                                                ? _c(
                                                    "span",
                                                    { staticClass: "error" },
                                                    [
                                                      _vm._v(
                                                        "Please enter your PO Box details"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.postaladdress
                                            .suburb_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Suburb")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.applicant2.postaladdress
                                                .suburb,
                                            expression:
                                              "applicant2.postaladdress.suburb",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled:
                                            _vm.applicant2.postaladdress
                                              .same_as,
                                          id: "applicant2_postaladdress_suburb",
                                          type: "text",
                                        },
                                        domProps: {
                                          value:
                                            _vm.applicant2.postaladdress.suburb,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2.postaladdress,
                                              "suburb",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.postaladdress.suburb_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v("Please enter your suburb"),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.postaladdress
                                            .state_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("State")]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2.postaladdress
                                                  .state,
                                              expression:
                                                "applicant2.postaladdress.state",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled:
                                              _vm.applicant2.postaladdress
                                                .same_as,
                                            id: "applicant2_postaladdress_state",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.applicant2.postaladdress,
                                                "state",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [_vm._v("Select State")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "ACT" } },
                                            [_vm._v("ACT")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "NSW" } },
                                            [_vm._v("NSW")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "NT" } },
                                            [_vm._v("NT")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "QLD" } },
                                            [_vm._v("QLD")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SA" } },
                                            [_vm._v("SA")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "TAS" } },
                                            [_vm._v("TAS")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "VIC" } },
                                            [_vm._v("VIC")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "WA" } },
                                            [_vm._v("WA")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.applicant2.postaladdress.state_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v("Please enter your state"),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        input_error:
                                          _vm.applicant2.postaladdress
                                            .post_code_error,
                                      },
                                    },
                                    [
                                      _c("label", [_vm._v("Postcode")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.applicant2.postaladdress
                                                .post_code,
                                            expression:
                                              "applicant2.postaladdress.post_code",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled:
                                            _vm.applicant2.postaladdress
                                              .same_as,
                                          id: "applicant2_postaladdress_post_code",
                                          type: "text",
                                        },
                                        domProps: {
                                          value:
                                            _vm.applicant2.postaladdress
                                              .post_code,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.applicant2.postaladdress,
                                              "post_code",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.applicant2.postaladdress
                                        .post_code_error
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              "Please enter your postcode"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.applicant2.postaladdress.validate_error
                                ? _c("p", { staticClass: "input_error" }, [
                                    _vm._m(4),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.applicant2.postaladdress
                                .validate_errorelectoral2
                                ? _c("p", { staticClass: "input_error" }, [
                                    _c("strong", [
                                      _vm._v(
                                        "We haven't been able to verify that your name matches your electoral role address, please\n                  contact us on (02) 8356 0300 during office hours to continue your application."
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.applicant2.postaladdress.validate_duplicate
                                ? _c("p", { staticClass: "input_error" }, [
                                    _c("strong", [
                                      _vm._v(
                                        "You are not able to complete the application process. Please contact (02) 8356 0300 to discuss\n                  your application."
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.validate_member
                    ? _c("p", { staticClass: "input_error" }, [
                        _c("strong", [
                          _vm._v(
                            "You are not able to complete the application process. Please contact (02) 8356 0300 to discuss your\n          application."
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.page == 2
            ? _c("div", { staticClass: "page", attrs: { "data-page": "2" } }, [
                _c("section", [
                  _c("div", { staticClass: "pd-2" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("h1", [
                        _c("span", { staticClass: "txtcap" }, [
                          _vm._v(_vm._s(_vm.applicant1.first_name)),
                        ]),
                        _vm._v(", please read below carefully and confirm"),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { input_error: _vm.applicant1.dec_1_error },
                        },
                        [
                          _c("div", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.applicant1.dec_1,
                                    expression: "applicant1.dec_1",
                                  },
                                ],
                                attrs: {
                                  id: "applicant1_dec_1",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.applicant1.dec_1)
                                    ? _vm._i(_vm.applicant1.dec_1, null) > -1
                                    : _vm.applicant1.dec_1,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.applicant1.dec_1,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_1",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_1",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.applicant1, "dec_1", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                  I declare that I am not a member, present or past, of another political party.\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { input_error: _vm.applicant1.dec_2_error },
                        },
                        [
                          _c("div", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.applicant1.dec_2,
                                    expression: "applicant1.dec_2",
                                  },
                                ],
                                attrs: {
                                  id: "applicant1_dec_2",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.applicant1.dec_2)
                                    ? _vm._i(_vm.applicant1.dec_2, null) > -1
                                    : _vm.applicant1.dec_2,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.applicant1.dec_2,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_2",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_2",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.applicant1, "dec_2", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                  I declare that I have never stood against, or assisted someone who stood against a Liberal endorsed\n                  Candidate in a Federal, State or Local Government election.\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.isJoint
                        ? _c("div", [
                            _c("h1", [
                              _c("span", { staticClass: "txtcap" }, [
                                _vm._v(_vm._s(_vm.applicant2.first_name)),
                              ]),
                              _vm._v(
                                ", please read below carefully and confirm\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant2.dec_1_error,
                                },
                              },
                              [
                                _c("div", { staticClass: "checkbox" }, [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.applicant2.dec_1,
                                          expression: "applicant2.dec_1",
                                        },
                                      ],
                                      attrs: {
                                        id: "applicant2_dec_1",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.applicant2.dec_1
                                        )
                                          ? _vm._i(_vm.applicant2.dec_1, null) >
                                            -1
                                          : _vm.applicant2.dec_1,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.applicant2.dec_1,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.applicant2,
                                                  "dec_1",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.applicant2,
                                                  "dec_1",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.applicant2,
                                              "dec_1",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                    I declare that I am not a member, present or past, of another political party.\n                  "
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant2.dec_2_error,
                                },
                              },
                              [
                                _c("div", { staticClass: "checkbox" }, [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.applicant2.dec_2,
                                          expression: "applicant2.dec_2",
                                        },
                                      ],
                                      attrs: {
                                        id: "applicant2_dec_2",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.applicant2.dec_2
                                        )
                                          ? _vm._i(_vm.applicant2.dec_2, null) >
                                            -1
                                          : _vm.applicant2.dec_2,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.applicant2.dec_2,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.applicant2,
                                                  "dec_2",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.applicant2,
                                                  "dec_2",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.applicant2,
                                              "dec_2",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                    I declare that I have never stood against, or assisted someone who stood against a Liberal\n                    endorsed Candidate in a Federal, State or Local Government election.\n                  "
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(6),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.page == 3
            ? _c("div", { staticClass: "page", attrs: { "data-page": "3" } }, [
                _c("section", [
                  _c("div", { staticClass: "pd-2 dark" }, [
                    _c(
                      "div",
                      { staticClass: "container" },
                      [
                        _c("h1", [
                          _vm._v("Please choose your level of Membership:"),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.isJoint
                          ? _c("label", [
                              _vm._v(
                                "Please note, the below prices are for the joint membership of you and your\n              partner."
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.products, function (product) {
                          return _c("div", [
                            _vm.applicant1.years <= product.age_limit &&
                            product.can_show
                              ? _c("div", [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      !_vm.isJoint
                                        ? _c("label", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  product.product_description
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isJoint && product.can_joint
                                        ? _c("label", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  product.product_description
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "checkbox text-right" },
                                        [
                                          !_vm.isJoint
                                            ? _c("label", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.applicant1.picked,
                                                      expression:
                                                        "applicant1.picked",
                                                    },
                                                  ],
                                                  attrs: { type: "radio" },
                                                  domProps: {
                                                    value: product.product_code,
                                                    checked: _vm._q(
                                                      _vm.applicant1.picked,
                                                      product.product_code
                                                    ),
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        return _vm.$set(
                                                          _vm.applicant1,
                                                          "picked",
                                                          product.product_code
                                                        )
                                                      },
                                                      _vm.updateProducts,
                                                    ],
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                        $" +
                                                    _vm._s(product.price) +
                                                    "\n                      "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isJoint && product.can_joint
                                            ? _c("label", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.applicant1.picked,
                                                      expression:
                                                        "applicant1.picked",
                                                    },
                                                  ],
                                                  attrs: { type: "radio" },
                                                  domProps: {
                                                    value: product.product_code,
                                                    checked: _vm._q(
                                                      _vm.applicant1.picked,
                                                      product.product_code
                                                    ),
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        return _vm.$set(
                                                          _vm.applicant1,
                                                          "picked",
                                                          product.product_code
                                                        )
                                                      },
                                                      _vm.updateProducts,
                                                    ],
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                        $" +
                                                    _vm._s(product.price * 2) +
                                                    "\n                      "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.isJoint && product.can_joint
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "col-md-3",
                                            staticStyle: {
                                              display: "none !important",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "checkbox text-right",
                                              },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.applicant2.picked,
                                                        expression:
                                                          "applicant2.picked",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value:
                                                        product.product_code,
                                                      checked: _vm._q(
                                                        _vm.applicant2.picked,
                                                        product.product_code
                                                      ),
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          return _vm.$set(
                                                            _vm.applicant2,
                                                            "picked",
                                                            product.product_code
                                                          )
                                                        },
                                                        _vm.updateProducts,
                                                      ],
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                        $" +
                                                      _vm._s(product.price) +
                                                      "\n                      "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("hr"),
                                ])
                              : _vm._e(),
                          ])
                        }),
                        _vm._v(" "),
                        _vm.applicant1.picked_error
                          ? _c("div", { staticClass: "error" }, [
                              _c("p", { staticClass: "bg-danger" }, [
                                _vm._v("\n                Please select "),
                                _c("span", { staticClass: "txtcap" }, [
                                  _vm._v(_vm._s(_vm.applicant1.first_name)),
                                ]),
                                _vm._v(" membership\n              "),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.applicant2.picked_error
                          ? _c("div", { staticClass: "error" }, [
                              _c("p", { staticClass: "bg-danger" }, [
                                _vm._v("\n                Please select "),
                                _c("span", { staticClass: "txtcap" }, [
                                  _vm._v(_vm._s(_vm.applicant2.first_name)),
                                ]),
                                _vm._v(" membership\n              "),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("div", { staticClass: "pd-2" }, [
                    _c("div", { staticClass: "container" }, [
                      _vm.applicant1.is_concession ||
                      _vm.applicant2.is_concession
                        ? _c("h1", [
                            _vm._v(
                              "Retired superannuants, Pensioners and\n              Students must provide proof to gain concession rates."
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.applicant1.is_concession
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant1.files[0].error,
                                },
                              },
                              [
                                _c("label", [
                                  _c("span", { staticClass: "txtcap" }, [
                                    _vm._v(_vm._s(_vm.applicant1.first_name)),
                                  ]),
                                  _vm._v(
                                    ", please upload your proof of concession\n                  here"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: {
                                    type: "file",
                                    accept: "image/*,application/pdf",
                                    id: "applicant1_concession",
                                  },
                                  on: { change: _vm.fileSelected },
                                }),
                                _vm._v(" "),
                                _vm.applicant1.files[0].error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please select a file"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.applicant1.files[0].blob
                                  ? _c("div", [
                                      _c("p", [
                                        _c("img", {
                                          staticClass: "img",
                                          attrs: {
                                            src: _vm.applicant1.files[0].blob,
                                            width: "300px",
                                          },
                                        }),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.applicant2.is_concession && _vm.isJoint
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant2.files[0].error,
                                },
                              },
                              [
                                _c("label", [
                                  _c("span", { staticClass: "txtcap" }, [
                                    _vm._v(_vm._s(_vm.applicant2.first_name)),
                                  ]),
                                  _vm._v(
                                    ", please upload your proof of concession\n                  here"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: {
                                    type: "file",
                                    accept: "image/*,application/pdf",
                                    id: "applicant2_concession",
                                  },
                                  on: { change: _vm.fileSelected },
                                }),
                                _vm._v(" "),
                                _vm.applicant2.files[0].error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please select a file"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.applicant2.files[0].blob
                                  ? _c("div", [
                                      _c("p", [
                                        _c("img", {
                                          staticClass: "img",
                                          attrs: {
                                            src: this.applicant2.files[0].blob,
                                            width: "300px",
                                          },
                                        }),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.page == 4
            ? _c("div", { staticClass: "page", attrs: { "data-page": "4" } }, [
                _c("section", [
                  _c("div", { staticClass: "pd-2 dark" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("h1", [_vm._v("Membership Options")]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("h3", { staticClass: "txtcap" }, [
                        _vm._v(_vm._s(_vm.applicant1.first_name)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            input_error: _vm.applicant1.branch_type_error,
                          },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _vm._m(7),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-9" }, [
                              _vm.applicant1.branches.length > 0
                                ? _c("label", { staticClass: "radio-inline" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.applicant1.branch_type,
                                          expression: "applicant1.branch_type",
                                        },
                                      ],
                                      attrs: { type: "radio", value: "branch" },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.applicant1.branch_type,
                                          "branch"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.applicant1,
                                            "branch_type",
                                            "branch"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                    Branch Member\n                  "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("label", { staticClass: "radio-inline" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applicant1.branch_type,
                                      expression: "applicant1.branch_type",
                                    },
                                  ],
                                  attrs: { type: "radio", value: "general" },
                                  domProps: {
                                    checked:
                                      _vm.applicant1.branch_type == "general",
                                    checked: _vm._q(
                                      _vm.applicant1.branch_type,
                                      "general"
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$set(
                                        _vm.applicant1,
                                        "branch_type",
                                        "general"
                                      )
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                    General Member\n                  "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.applicant1.branch_type_error
                            ? _c("span", { staticClass: "error" }, [
                                _vm._v("Please select a branch type"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("hr"),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isJoint
                        ? _c("div", [
                            _c("h3", { staticClass: "txtcap" }, [
                              _vm._v(_vm._s(_vm.applicant2.first_name)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error: _vm.applicant2.branch_type_error,
                                },
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _vm.applicant2.branches.length > 0
                                      ? _c(
                                          "label",
                                          { staticClass: "radio-inline" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.applicant2.branch_type,
                                                  expression:
                                                    "applicant2.branch_type",
                                                },
                                              ],
                                              attrs: {
                                                type: "radio",
                                                value: "branch",
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.applicant2.branch_type,
                                                  "branch"
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.applicant2,
                                                    "branch_type",
                                                    "branch"
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              "\n                      Branch Member\n                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "radio-inline" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.applicant2.branch_type,
                                              expression:
                                                "applicant2.branch_type",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            value: "general",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.applicant2.branch_type,
                                              "general"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.applicant2,
                                                "branch_type",
                                                "general"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                      General Member\n                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.applicant2.branch_type_error
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v("Please select a branch type"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.applicant1.branch_type == "branch" ||
                  _vm.applicant2.branch_type == "branch"
                    ? _c("div", { staticClass: "pd-2" }, [
                        _c(
                          "div",
                          { staticClass: "container" },
                          [
                            _c("h1", [_vm._v("Membership Options")]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("transition", { attrs: { name: "fade" } }, [
                              _vm.applicant1.branch_type == "branch"
                                ? _c("div", [
                                    _c("h3", { staticClass: "txtcap" }, [
                                      _vm._v(_vm._s(_vm.applicant1.first_name)),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            class: {
                                              input_error:
                                                _vm.applicant1
                                                  .branch_code_error,
                                            },
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                "I would like to apply to join the"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.applicant1
                                                        .branch_code,
                                                    expression:
                                                      "applicant1.branch_code",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      _vm.applicant1,
                                                      "branch_code",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { domProps: { value: null } },
                                                  [_vm._v("Please Select")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.applicant1.branches,
                                                  function (branch) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value:
                                                            branch.branch_code,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              branch.branch_name
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _vm.applicant1.branch_code_error
                                              ? _c(
                                                  "span",
                                                  { staticClass: "error" },
                                                  [
                                                    _vm._v(
                                                      "Please select a branch"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("hr"),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("transition", { attrs: { name: "fade" } }, [
                              _vm.applicant2.branch_type == "branch"
                                ? _c("div", [
                                    _c("h3", { staticClass: "txtcap" }, [
                                      _vm._v(_vm._s(_vm.applicant2.first_name)),
                                    ]),
                                    _vm._v(" "),
                                    _vm.isJoint
                                      ? _c("div", [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form-group",
                                                    class: {
                                                      input_error:
                                                        _vm.applicant2
                                                          .branch_code_error,
                                                    },
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        "I would like to apply to join the"
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.applicant2
                                                                .branch_code,
                                                            expression:
                                                              "applicant2.branch_code",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.$set(
                                                              _vm.applicant2,
                                                              "branch_code",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value: null,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Please Select"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.applicant2
                                                            .branches,
                                                          function (branch) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                domProps: {
                                                                  value:
                                                                    branch.branch_code,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      branch.branch_name
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.applicant2
                                                      .branch_code_error
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Please select a branch"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.page == 5
            ? _c("div", { staticClass: "page", attrs: { "data-page": "5" } }, [
                _c("section", [
                  _c("div", { staticClass: "pd-2 dark" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("h1", [_vm._v("Membership Declaration")]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("h3", { staticClass: "txtcap" }, [
                        _vm._v(_vm._s(_vm.applicant1.first_name)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            input_error:
                              _vm.applicant1.dec_prohibited_funding_error,
                          },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _vm._m(9),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.applicant1.dec_prohibited_funding,
                                        expression:
                                          "applicant1.dec_prohibited_funding",
                                      },
                                    ],
                                    attrs: { type: "radio", value: "yes" },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.applicant1.dec_prohibited_funding,
                                        "yes"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.applicant1,
                                          "dec_prohibited_funding",
                                          "yes"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      Yes\n                    "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.applicant1.dec_prohibited_funding,
                                        expression:
                                          "applicant1.dec_prohibited_funding",
                                      },
                                    ],
                                    attrs: { type: "radio", value: "no" },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.applicant1.dec_prohibited_funding,
                                        "no"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.applicant1,
                                          "dec_prohibited_funding",
                                          "no"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      No\n                    "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            input_error: _vm.applicant1.dec_lobbyist_error,
                          },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _vm._m(10),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.applicant1.dec_lobbyist,
                                        expression: "applicant1.dec_lobbyist",
                                      },
                                    ],
                                    attrs: { type: "radio", value: "yes" },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.applicant1.dec_lobbyist,
                                        "yes"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.applicant1,
                                          "dec_lobbyist",
                                          "yes"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      Yes\n                    "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.applicant1.dec_lobbyist,
                                        expression: "applicant1.dec_lobbyist",
                                      },
                                    ],
                                    attrs: { type: "radio", value: "no" },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.applicant1.dec_lobbyist,
                                        "no"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.applicant1,
                                          "dec_lobbyist",
                                          "no"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      No\n                    "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            input_error:
                              _vm.applicant1.dec_previous_member_error,
                          },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _vm._m(11),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.applicant1.dec_previous_member,
                                        expression:
                                          "applicant1.dec_previous_member",
                                      },
                                    ],
                                    attrs: { type: "radio", value: "yes" },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.applicant1.dec_previous_member,
                                        "yes"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.applicant1,
                                          "dec_previous_member",
                                          "yes"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      Yes\n                    "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.applicant1.dec_previous_member,
                                        expression:
                                          "applicant1.dec_previous_member",
                                      },
                                    ],
                                    attrs: { type: "radio", value: "no" },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.applicant1.dec_previous_member,
                                        "no"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.applicant1,
                                          "dec_previous_member",
                                          "no"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      No\n                    "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.applicant1.dec_previous_member == "yes"
                        ? _c(
                            "div",
                            {
                              staticClass: "form-group",
                              class: {
                                input_error: _vm.applicant1.dec_suspended_error,
                              },
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _vm._m(12),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-3" }, [
                                  _c("div", { staticClass: "checkbox" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.applicant1.dec_suspended,
                                            expression:
                                              "applicant1.dec_suspended",
                                          },
                                        ],
                                        attrs: { type: "radio", value: "yes" },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.applicant1.dec_suspended,
                                            "yes"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.applicant1,
                                              "dec_suspended",
                                              "yes"
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n                      Yes\n                    "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "checkbox" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.applicant1.dec_suspended,
                                            expression:
                                              "applicant1.dec_suspended",
                                          },
                                        ],
                                        attrs: { type: "radio", value: "no" },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.applicant1.dec_suspended,
                                            "no"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.applicant1,
                                              "dec_suspended",
                                              "no"
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n                      No\n                    "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.applicant1.dec_suspended == "yes"
                        ? _c(
                            "div",
                            {
                              staticClass: "form-group",
                              class: {
                                input_error:
                                  _vm.applicant1.dec_suspendedmsg_error,
                              },
                            },
                            [
                              _vm._m(13),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.applicant1.dec_suspendedmsg,
                                        expression:
                                          "applicant1.dec_suspendedmsg",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "applicant1_dec_suspendedmsg",
                                      type: "text",
                                    },
                                    domProps: {
                                      value: _vm.applicant1.dec_suspendedmsg,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.applicant1,
                                          "dec_suspendedmsg",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.applicant1.dec_suspendedmsg_error
                                    ? _c("span", { staticClass: "error" }, [
                                        _vm._v("Please provide details"),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.isJoint
                  ? _c("div", [
                      _c("section", [
                        _c("div", { staticClass: "pd-2" }, [
                          _c("div", { staticClass: "container" }, [
                            _c("h3", { staticClass: "txtcap" }, [
                              _vm._v(_vm._s(_vm.applicant2.first_name)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant2.dec_prohibited_funding_error,
                                },
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(14),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c("div", { staticClass: "checkbox" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2
                                                  .dec_prohibited_funding,
                                              expression:
                                                "applicant2.dec_prohibited_funding",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            value: "yes",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.applicant2
                                                .dec_prohibited_funding,
                                              "yes"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.applicant2,
                                                "dec_prohibited_funding",
                                                "yes"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                        Yes\n                      "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "checkbox" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2
                                                  .dec_prohibited_funding,
                                              expression:
                                                "applicant2.dec_prohibited_funding",
                                            },
                                          ],
                                          attrs: { type: "radio", value: "no" },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.applicant2
                                                .dec_prohibited_funding,
                                              "no"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.applicant2,
                                                "dec_prohibited_funding",
                                                "no"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                        No\n                      "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant2.dec_lobbyist_error,
                                },
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(15),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c("div", { staticClass: "checkbox" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2.dec_lobbyist,
                                              expression:
                                                "applicant2.dec_lobbyist",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            value: "yes",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.applicant2.dec_lobbyist,
                                              "yes"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.applicant2,
                                                "dec_lobbyist",
                                                "yes"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                        Yes\n                      "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "checkbox" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2.dec_lobbyist,
                                              expression:
                                                "applicant2.dec_lobbyist",
                                            },
                                          ],
                                          attrs: { type: "radio", value: "no" },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.applicant2.dec_lobbyist,
                                              "no"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.applicant2,
                                                "dec_lobbyist",
                                                "no"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                        No\n                      "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  input_error:
                                    _vm.applicant2.dec_previous_member_error,
                                },
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(16),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c("div", { staticClass: "checkbox" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2
                                                  .dec_previous_member,
                                              expression:
                                                "applicant2.dec_previous_member",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            value: "yes",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.applicant2
                                                .dec_previous_member,
                                              "yes"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.applicant2,
                                                "dec_previous_member",
                                                "yes"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                        Yes\n                      "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "checkbox" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2
                                                  .dec_previous_member,
                                              expression:
                                                "applicant2.dec_previous_member",
                                            },
                                          ],
                                          attrs: { type: "radio", value: "no" },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.applicant2
                                                .dec_previous_member,
                                              "no"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.applicant2,
                                                "dec_previous_member",
                                                "no"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                        No\n                      "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _vm.applicant2.dec_previous_member == "yes"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.applicant2.dec_suspended_error,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(17),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c("div", { staticClass: "checkbox" }, [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.applicant2
                                                      .dec_suspended,
                                                  expression:
                                                    "applicant2.dec_suspended",
                                                },
                                              ],
                                              attrs: {
                                                type: "radio",
                                                value: "yes",
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.applicant2.dec_suspended,
                                                  "yes"
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.applicant2,
                                                    "dec_suspended",
                                                    "yes"
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              "\n                        Yes\n                      "
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "checkbox" }, [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.applicant2
                                                      .dec_suspended,
                                                  expression:
                                                    "applicant2.dec_suspended",
                                                },
                                              ],
                                              attrs: {
                                                type: "radio",
                                                value: "no",
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.applicant2.dec_suspended,
                                                  "no"
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.applicant2,
                                                    "dec_suspended",
                                                    "no"
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              "\n                        No\n                      "
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.applicant2.dec_suspended == "yes"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.applicant2.dec_suspendedmsg_error,
                                    },
                                  },
                                  [
                                    _vm._m(18),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.applicant2.dec_suspendedmsg,
                                              expression:
                                                "applicant2.dec_suspendedmsg",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "applicant2_dec_suspendedmsg",
                                            type: "text",
                                          },
                                          domProps: {
                                            value:
                                              _vm.applicant2.dec_suspendedmsg,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.applicant2,
                                                "dec_suspendedmsg",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.applicant2.dec_suspendedmsg_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [_vm._v("Please provide details")]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.page == 6
            ? _c("div", { staticClass: "page", attrs: { "data-page": "6" } }, [
                !_vm.userIsTelemarketer
                  ? _c("section", [
                      _c("div", { staticClass: "pd-2 dark" }, [
                        _c("div", { staticClass: "container" }, [
                          _c("h1", [_vm._v("Proof of ID")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                              class: {
                                input_error: _vm.applicant1.files[1].error,
                              },
                            },
                            [
                              _c("label", [
                                _c("span", { staticClass: "txtcap" }, [
                                  _vm._v(_vm._s(_vm.applicant1.first_name)),
                                ]),
                                _vm._v(
                                  ", upload your proof of ID. This can be a\n                photo of your drivers licence, proof of age or passport."
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "file",
                                  accept: "image/*,application/pdf",
                                  id: "applicant1_identity",
                                },
                                on: { change: _vm.fileSelected },
                              }),
                              _vm._v(" "),
                              _vm.applicant1.files[1].error
                                ? _c("span", { staticClass: "error" }, [
                                    _vm._v("Please select a file"),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.applicant1.files[1].blob
                                ? _c("div", [
                                    _c("p", [
                                      _c("img", {
                                        staticClass: "img",
                                        attrs: {
                                          src: _vm.applicant1.files[1].blob,
                                          width: "300px",
                                        },
                                      }),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isJoint
                            ? _c("div", [
                                _c("hr"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.applicant2.files[1].error,
                                    },
                                  },
                                  [
                                    _c("label", [
                                      _c("span", { staticClass: "txtcap" }, [
                                        _vm._v(
                                          _vm._s(_vm.applicant2.first_name)
                                        ),
                                      ]),
                                      _vm._v(
                                        ", upload your proof of ID. This can be a\n                  photo of your drivers licence, proof of age or passport."
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "file",
                                        accept: "image/*,application/pdf",
                                        id: "applicant2_identity",
                                      },
                                      on: { change: _vm.fileSelected },
                                    }),
                                    _vm._v(" "),
                                    _vm.applicant2.files[1].error
                                      ? _c("span", { staticClass: "error" }, [
                                          _vm._v("Please select a file"),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.applicant2.files[1].blob
                                      ? _c("div", [
                                          _c("p", [
                                            _c("img", {
                                              staticClass: "img",
                                              attrs: {
                                                src: this.applicant2.files[1]
                                                  .blob,
                                                width: "300px",
                                              },
                                            }),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("section", [
                  _c("div", { staticClass: "pd-2" }, [
                    _c(
                      "div",
                      { staticClass: "container" },
                      [
                        _c("h1", [_vm._v("Donation Optional")]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("label", [
                          _vm.isJoint ? _c("span", [_vm._v("We")]) : _vm._e(),
                          !_vm.isJoint ? _c("span", [_vm._v("I")]) : _vm._e(),
                          _vm._v(
                            " would like to make a donation in support of\n              the Liberal Party to compete against the enormous resources of the union backed Labor Party.\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Donation Details")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v("* "),
                            _vm.isJoint ? _c("span", [_vm._v("We")]) : _vm._e(),
                            !_vm.isJoint ? _c("span", [_vm._v("I")]) : _vm._e(),
                            _vm._v(" would like to donate"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "donation-grid" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                class: { selected: _vm.donationAmount(25) },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateSetDonation(25)
                                  },
                                },
                              },
                              [_vm._v("$25")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                class: { selected: _vm.donationAmount(50) },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateSetDonation(50)
                                  },
                                },
                              },
                              [_vm._v("$50")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                class: { selected: _vm.donationAmount(100) },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateSetDonation(100)
                                  },
                                },
                              },
                              [_vm._v("$100")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                class: { selected: _vm.donationAmount(500) },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateSetDonation(500)
                                  },
                                },
                              },
                              [_vm._v("$500")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                class: { selected: _vm.donationAmount(1000) },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateSetDonation(1000)
                                  },
                                },
                              },
                              [_vm._v("$1000")]
                            ),
                            _vm._v(" "),
                            _vm.payment.donation.set_amount
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.updateSetDonation(0)
                                      },
                                    },
                                  },
                                  [_vm._v("No\n                  Donation")]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          !_vm.payment.donation.set_amount
                            ? _c("div", [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.payment.donation
                                              .donation_amount_error,
                                        },
                                      },
                                      [
                                        _c("label", [
                                          _vm._v("Insert Other Amount"),
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.payment.donation
                                                  .donation_amount,
                                              expression:
                                                "payment.donation.donation_amount",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { id: "other-amount" },
                                          domProps: {
                                            value:
                                              _vm.payment.donation
                                                .donation_amount,
                                          },
                                          on: {
                                            change: _vm.updateProducts,
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.payment.donation,
                                                "donation_amount",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.payment.donation
                                          .donation_amount_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter a valid number"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.payment.donation.monthly,
                                  expression: "payment.donation.monthly",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.payment.donation.monthly
                                )
                                  ? _vm._i(_vm.payment.donation.monthly, null) >
                                    -1
                                  : _vm.payment.donation.monthly,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.payment.donation.monthly,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.payment.donation,
                                          "monthly",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.payment.donation,
                                          "monthly",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.payment.donation,
                                      "monthly",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              "\n                Please tick this box if you are interested in making a monthly donation to the Liberal Party NSW.\n              "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("div", { staticClass: "pd-2 dark" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("h1", [_vm._v("Payment Declaration")]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { input_error: _vm.applicant1.dec_fee_error },
                        },
                        [
                          _c("div", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.applicant1.dec_fee,
                                    expression: "applicant1.dec_fee",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.applicant1.dec_fee)
                                    ? _vm._i(_vm.applicant1.dec_fee, null) > -1
                                    : _vm.applicant1.dec_fee,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.applicant1.dec_fee,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_fee",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_fee",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.applicant1, "dec_fee", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.isJoint
                                ? _c("span", [_vm._v("We")])
                                : _c("span", [_vm._v("I")]),
                              _vm._v(
                                " acknowledge that a membership fee may only be\n                  paid by the applicant or the applicant's spouse or parents (provided that the person effecting\n                  payment is enrolled to vote in Federal or State elections in NSW).\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          staticStyle: { display: "none" },
                        },
                        [
                          _c("div", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.payment.membership.renew,
                                    expression: "payment.membership.renew",
                                  },
                                ],
                                staticStyle: { display: "none" },
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.payment.membership.renew
                                  )
                                    ? _vm._i(
                                        _vm.payment.membership.renew,
                                        null
                                      ) > -1
                                    : _vm.payment.membership.renew,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.payment.membership.renew,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.payment.membership,
                                            "renew",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.payment.membership,
                                            "renew",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.payment.membership,
                                        "renew",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.isJoint
                                ? _c("span", [_vm._v("We")])
                                : _c("span", [_vm._v("I")]),
                              _vm._v(
                                " would like to renew our membership automatically\n                  each year.\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { input_error: _vm.applicant1.dec_year_error },
                        },
                        [
                          _c("div", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.applicant1.dec_year,
                                    expression: "applicant1.dec_year",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.applicant1.dec_year
                                  )
                                    ? _vm._i(_vm.applicant1.dec_year, null) > -1
                                    : _vm.applicant1.dec_year,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.applicant1.dec_year,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_year",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_year",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.applicant1, "dec_year", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.isJoint
                                ? _c("span", [_vm._v("We")])
                                : _c("span", [_vm._v("I")]),
                              _vm._v(
                                " acknowledge that the membership year of the\n                  Liberal Party is from 1 July to 30 June. "
                              ),
                              _vm.isJoint
                                ? _c("span", [_vm._v("We")])
                                : _vm._e(),
                              !_vm.isJoint
                                ? _c("span", [_vm._v("I")])
                                : _vm._e(),
                              _vm._v(
                                " understand this payment covers my membership from now until the end of\n                  the current financial year.\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "checkbox",
                            class: {
                              input_error:
                                _vm.applicant1.dec_constitution_error,
                            },
                          },
                          [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.applicant1.dec_constitution,
                                    expression: "applicant1.dec_constitution",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.applicant1.dec_constitution
                                  )
                                    ? _vm._i(
                                        _vm.applicant1.dec_constitution,
                                        null
                                      ) > -1
                                    : _vm.applicant1.dec_constitution,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.applicant1.dec_constitution,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_constitution",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.applicant1,
                                            "dec_constitution",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.applicant1,
                                        "dec_constitution",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.isJoint
                                ? _c("span", [_vm._v("We")])
                                : _c("span", [_vm._v("I")]),
                              _vm._v(
                                " agree to be bound by the Constitution of the\n                  Liberal Party of Australia, NSW Division.\n                "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("h2", [_vm._v("Payment Information")]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-8" }, [
                          _c("section", { attrs: { id: "pnlAmountPayble" } }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("div", { staticClass: "row" }, [
                                _vm._m(19),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-7" }, [
                                  _c("label", [
                                    _vm._v(
                                      "$" +
                                        _vm._s(_vm.payment.membership.amount)
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.userHasStaffPaymentTypes
                            ? _c(
                                "section",
                                { attrs: { id: "pnlPaymentMethod" } },
                                [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(20),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-7" }, [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.payment.membership
                                                    .payment_type,
                                                expression:
                                                  "payment.membership.payment_type",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              disabled:
                                                !_vm.validate_declaration,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.payment.membership,
                                                  "payment_type",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "CC" } },
                                              [_vm._v("Credit card")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "Cheque" } },
                                              [_vm._v("Cheque")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "Cash" } },
                                              [_vm._v("Cash")]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.payment.membership.payment_type ||
                          _vm.payment.membership.payment_type == "CC"
                            ? _c("section", { attrs: { id: "pnlCC" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.payment.membership.card_type_error,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(21),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-7" }, [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.payment.membership
                                                    .card_type,
                                                expression:
                                                  "payment.membership.card_type",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              disabled:
                                                !_vm.validate_declaration,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.payment.membership,
                                                  "card_type",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { domProps: { value: null } },
                                              [_vm._v("Please Select")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "VISA" } },
                                              [_vm._v("VISA")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "MC" } },
                                              [_vm._v("MASTERCARD")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "AMEX" } },
                                              [_vm._v("AMERICAN EXPRESS")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.payment.membership.card_type_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please select a card type"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.payment.membership
                                          .card_number_error,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(22),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-7" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.payment.membership
                                                  .card_number,
                                              expression:
                                                "payment.membership.card_number",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            disabled: !_vm.validate_declaration,
                                            placeholder: "",
                                          },
                                          domProps: {
                                            value:
                                              _vm.payment.membership
                                                .card_number,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.payment.membership,
                                                "card_number",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.payment.membership.card_number_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter a valid card number"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.payment.membership
                                          .card_holder_error,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(23),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-7" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.payment.membership
                                                  .card_holder,
                                              expression:
                                                "payment.membership.card_holder",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            disabled: !_vm.validate_declaration,
                                            placeholder: "",
                                          },
                                          domProps: {
                                            value:
                                              _vm.payment.membership
                                                .card_holder,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.payment.membership,
                                                "card_holder",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.payment.membership.card_holder_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter the card holder's name"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("div", { staticClass: "row" }, [
                                    _vm._m(24),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-7" }, [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 col-xs-6" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: {
                                                  input_error:
                                                    _vm.payment.membership
                                                      .expire_month_error,
                                                },
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payment.membership
                                                            .expire_month,
                                                        expression:
                                                          "payment.membership.expire_month",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control col-sm-12",
                                                    attrs: {
                                                      disabled:
                                                        !_vm.validate_declaration,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.$set(
                                                          _vm.payment
                                                            .membership,
                                                          "expire_month",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value: null,
                                                        },
                                                      },
                                                      [_vm._v("Month")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "01" },
                                                      },
                                                      [_vm._v("01")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "02" },
                                                      },
                                                      [_vm._v("02")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "03" },
                                                      },
                                                      [_vm._v("03")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "04" },
                                                      },
                                                      [_vm._v("04")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "05" },
                                                      },
                                                      [_vm._v("05")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "06" },
                                                      },
                                                      [_vm._v("06")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "07" },
                                                      },
                                                      [_vm._v("07")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "08" },
                                                      },
                                                      [_vm._v("08")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "09" },
                                                      },
                                                      [_vm._v("09")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "10" },
                                                      },
                                                      [_vm._v("10")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "11" },
                                                      },
                                                      [_vm._v("11")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "12" },
                                                      },
                                                      [_vm._v("12")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 col-xs-6" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: {
                                                  input_error:
                                                    _vm.payment.membership
                                                      .expire_year_error,
                                                },
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payment.membership
                                                            .expire_year,
                                                        expression:
                                                          "payment.membership.expire_year",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      disabled:
                                                        !_vm.validate_declaration,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.$set(
                                                          _vm.payment
                                                            .membership,
                                                          "expire_year",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value: null,
                                                        },
                                                      },
                                                      [_vm._v("Year")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.expiry_years,
                                                      function (year) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value: year,
                                                            },
                                                          },
                                                          [_vm._v(_vm._s(year))]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                !_vm.hideCCV
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "form-group",
                                        class: {
                                          input_error:
                                            _vm.payment.membership.ccv_error,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _vm._m(25),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-7" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.payment.membership
                                                        .ccv,
                                                    expression:
                                                      "payment.membership.ccv",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  disabled:
                                                    !_vm.validate_declaration,
                                                  placeholder: "Security Code",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.payment.membership.ccv,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.payment.membership,
                                                      "ccv",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.payment.membership.ccv_error
                                                ? _c(
                                                    "span",
                                                    { staticClass: "error" },
                                                    [
                                                      _vm._v(
                                                        "Please enter the CCV"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.payment.membership.payment_type == "Cheque"
                            ? _c("section", { attrs: { id: "pnlCheque" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.payment.membership.bsb_error,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(26),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-7" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.payment.membership.bsb,
                                              expression:
                                                "payment.membership.bsb",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            disabled: !_vm.validate_declaration,
                                            id: "txtBSB",
                                            placeholder: "",
                                          },
                                          domProps: {
                                            value: _vm.payment.membership.bsb,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.payment.membership,
                                                "bsb",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.payment.membership.bsb_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [_vm._v("Please enter the BSB")]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.payment.membership.cheque_no_error,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(27),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-7" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.payment.membership
                                                  .cheque_no,
                                              expression:
                                                "payment.membership.cheque_no",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            disabled: !_vm.validate_declaration,
                                            id: "txtChequeNo",
                                            placeholder: "",
                                          },
                                          domProps: {
                                            value:
                                              _vm.payment.membership.cheque_no,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.payment.membership,
                                                "cheque_no",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.payment.membership.cheque_no_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter the Cheque Number"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.payment.membership.acc_holder_error,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(28),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-7" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.payment.membership
                                                  .acc_holder,
                                              expression:
                                                "payment.membership.acc_holder",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            disabled: !_vm.validate_declaration,
                                            id: "txtAccHolder",
                                            placeholder: "",
                                          },
                                          domProps: {
                                            value:
                                              _vm.payment.membership.acc_holder,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.payment.membership,
                                                "acc_holder",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.payment.membership.acc_holder_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please enter the Account Holder's Name"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.payment.membership.payment_type == "Cash"
                            ? _c("section", { attrs: { id: "pnlCash" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      input_error:
                                        _vm.payment.membership
                                          .cash_account_error,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(29),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-7" }, [
                                        _c("label", {
                                          staticStyle: { display: "none" },
                                          attrs: {
                                            id: "lblCashAccount",
                                            title: "",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.payment.membership
                                                    .cash_account,
                                                expression:
                                                  "payment.membership.cash_account",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              id: "ddlcash_account",
                                              disabled:
                                                !_vm.validate_declaration,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.payment.membership,
                                                  "cash_account",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          _vm._l(
                                            _vm.cash_accounts_list_data,
                                            function (items) {
                                              return _c(
                                                "option",
                                                { domProps: { value: items } },
                                                [_vm._v(_vm._s(items))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _vm.payment.membership
                                          .cash_account_error
                                          ? _c(
                                              "span",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  "Please select Cash Account"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _vm._m(30),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary next",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    !_vm.validate_declaration ||
                                    _vm.captcha_verifying,
                                },
                                on: { click: _vm.validate },
                              },
                              [
                                _vm.captcha_verifying
                                  ? _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    })
                                  : _vm._e(),
                                _vm._v(" Pay Now\n                  "),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _vm.payment.result.errors.length > 0
                              ? _c(
                                  "ul",
                                  { staticClass: "alert-danger" },
                                  _vm._l(
                                    _vm.payment.result.errors,
                                    function (item) {
                                      return _c("li", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(item) +
                                            "\n                    "
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.page == 7
            ? _c("div", { staticClass: "page", attrs: { "data-page": "7" } }, [
                _c("section", [
                  _c("div", { staticClass: "pd-2 dark" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("h1", [_vm._v("Thank You")]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          " Thank you for applying to join the NSW Liberal Party. You will shortly receive a confirmation email\n              with details of how you can track the progress of your application, along with your receipt for payment\n              of your membership fee. "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._m(31),
                      _vm._v(" "),
                      _c("div", [
                        _c("h3", [
                          _vm._v("Transaction Reference Number: "),
                          _c("span", { staticClass: "highlight" }, [
                            _vm._v(
                              _vm._s(_vm.payment.result.valid.reference_number)
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v("Amount Paid: "),
                          _c("span", { staticClass: "highlight" }, [
                            _vm._v(
                              "$" + _vm._s(_vm.payment.result.valid.amount_paid)
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("section", [
          _c("div", { staticClass: "pd-2 progress-container" }, [
            _c("div", { staticClass: "container" }, [
              _c("h3", [_vm._v("Your Progress")]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6 offset-md-3" }, [
                  _c("div", { staticClass: "progress-outer" }, [
                    _c("div", {
                      staticClass: "progress-inner",
                      style: _vm.progress,
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "next-but" }, [
                _vm.page > 1 && _vm.page < 6
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary",
                          on: { click: _vm.validateback },
                        },
                        [
                          _c("i", { staticClass: "fa fa-chevron-left" }),
                          _vm._v(" Back"),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.page < 6
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary next",
                          on: { click: _vm.validate },
                        },
                        [
                          _vm._v("Next "),
                          _c("i", { staticClass: "fa fa-chevron-right" }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-5" }, [
      _c("div", { staticClass: "bt-lh" }, [
        _c("label", [
          _vm._v("Are you applying for single or joint membership?"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _vm._v(
        "We haven't been able to verify that your name matches your electoral roll address, please ensure\n                you have entered your electoral roll address and name correctly. To check your Electoral Roll address\n                please go to:"
      ),
      _c(
        "a",
        { attrs: { href: "https://check.aec.gov.au/", target: "_blank" } },
        [_vm._v("\n                  https://check.aec.gov.au/")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _vm._v(
        "We haven't been able to verify that your name matches your electoral role address, please\n                  ensure you have entered your electoral role address and name correctly. To check your Electoral Roll\n                  address please go to:"
      ),
      _c(
        "a",
        { attrs: { href: "https://check.aec.gov.au/", target: "_blank" } },
        [_vm._v("\n                    https://check.aec.gov.au/")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _vm._v(
        "We haven't been able to verify that your name matches your electoral role address, please ensure\n                you have entered your electoral role address and name correctly. To check your Electoral Roll address\n                please go to:"
      ),
      _c(
        "a",
        { attrs: { href: "https://check.aec.gov.au/", target: "_blank" } },
        [_vm._v("\n                  https://check.aec.gov.au/")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _vm._v(
        "We haven't been able to verify that your name matches your electoral role address, please\n                  ensure you have entered your electoral role address and name correctly. To check your Electoral Roll\n                  address please go to:"
      ),
      _c(
        "a",
        { attrs: { href: "https://check.aec.gov.au/", target: "_blank" } },
        [_vm._v("\n                    https://check.aec.gov.au/")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", [
        _c("label", [
          _vm._v(
            "\n                  If you are unable to make these declarations you are unable to proceed with your application online.\n                  Please contact us on 02 8356 0300 during office hours.\n                "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", [
        _c("label", [
          _vm._v(
            "\n                    If you are unable to make these declarations you are unable to proceed with your application\n                    online. Please contact us on 02 8356 0300 during office hours.\n                  "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v(" I would like to join as a ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v(" I would like to join as a ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("label", [
        _vm._v(
          "Are you a prohibited donor under the Electoral Funding Act 2018? "
        ),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.elections.nsw.gov.au/Funding-and-disclosure/Political-donations/Unlawful-political-donations/Prohibited-donors",
              target: "_blank",
            },
          },
          [_vm._v("Click here")]
        ),
        _vm._v(" to find out more."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("label", [
        _vm._v(
          "Are you a lobbyist registered under the NSW Register of Third Party Lobbyists or the\n                    Australian Government Register of Lobbyists?"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("label", [
        _vm._v(
          "Have you previously been a member of the Liberal Party of Australia?"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("label", [
        _vm._v(
          "If so, have you ever been suspended or expelled from the Party?"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("label", [_vm._v("If you answered yes, please provide details.")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("label", [
        _vm._v(
          "Are you a prohibited donor under the Electoral Funding Act 2018? "
        ),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.elections.nsw.gov.au/Funding-and-disclosure/Political-donations/Unlawful-political-donations/Prohibited-donors",
              target: "_blank",
            },
          },
          [_vm._v("Click here")]
        ),
        _vm._v(" to find out more."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("label", [
        _vm._v(
          "Are you a lobbyist registered under the NSW Register of Third Party Lobbyists or the\n                      Australian Government Register of Lobbyists?"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("label", [
        _vm._v(
          "Have you previously been a member of the Liberal Party of Australia?"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("label", [
        _vm._v(
          "If so, have you ever been suspended or expelled from the Party?"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("label", [_vm._v("If you answered yes, please provide details.")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("Amount Payable")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("* Payment type")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("* CARD TYPE")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("* CARD NUMBER")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("* CARD HOLDER NAME")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("*EXPIRATION DATE")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("*CCV")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("* BSB")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("* Cheque number")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("* Account holder's name")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("* Cash account")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("label", [_vm._v("No other payment details are required")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        " If you have any questions regarding your application, please contact our Membership Team by email at\n              "
      ),
      _c("a", { attrs: { href: "mailto:membership@nsw.liberal.org.au" } }, [
        _vm._v("membership@nsw.liberal.org.au"),
      ]),
      _vm._v(", or by phone on "),
      _c("a", { attrs: { href: "tel:(02) 8356 0300" } }, [
        _vm._v("(02) 8356 0300"),
      ]),
      _vm._v(". "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }